module.exports = __webpack_public_path__ + "static/media/fisk-min.43861041.png";